import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.MAINTENANCES,
  nodeType: Generator.NODETYPE.GET,
  suffixType: 'FULL'
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/maintenances/get/full.js